import { render, staticRenderFns } from "./ReportMeal.vue?vue&type=template&id=3edba626&scoped=true&"
import script from "./ReportMeal.vue?vue&type=script&lang=js&"
export * from "./ReportMeal.vue?vue&type=script&lang=js&"
import style0 from "./ReportMeal.vue?vue&type=style&index=0&id=3edba626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edba626",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1532393991/src/playtient-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edba626')) {
      api.createRecord('3edba626', component.options)
    } else {
      api.reload('3edba626', component.options)
    }
    module.hot.accept("./ReportMeal.vue?vue&type=template&id=3edba626&scoped=true&", function () {
      api.rerender('3edba626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/ReportMeal.vue"
export default component.exports